module.exports = __webpack_public_path__ + "static/media/captan_ultra.21e1bdc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/botrytis_fresa/preventiva/captan_ultra.png
// module id = 1543
// module chunks = 3